import { render } from "./MutableScrollableListView2.vue?vue&type=template&id=038b9d04&scoped=true"
import script from "./MutableScrollableListView2.vue?vue&type=script&lang=js"
export * from "./MutableScrollableListView2.vue?vue&type=script&lang=js"

import "./MutableScrollableListView2.vue?vue&type=style&index=0&id=038b9d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038b9d04"]])

export default __exports__